// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Int from "@rescript/core/src/Core__Int.bs.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as CardPattern$OrcaPaymentPage from "./CardPattern.bs.js";

function toInt(val) {
  return Core__Option.getOr(Core__Int.fromString(val, undefined), 0);
}

function getobjFromCardPattern(cardBrand) {
  return Core__Option.getOr(CardPattern$OrcaPaymentPage.cardPatterns.filter(item => cardBrand === item.issuer)[0], CardPattern$OrcaPaymentPage.defaultCardPattern);
}

function clearSpaces(value) {
  return value.replace(/\D+/g, "");
}

function slice(val, start, end) {
  return val.slice(start, end);
}

function getAllMatchedCardSchemes(cardNumber) {
  return Core__Array.reduce(CardPattern$OrcaPaymentPage.cardPatterns, [], (acc, item) => {
    if (Core__Option.isSome(Primitive_option.fromNullable(cardNumber.match(item.pattern)))) {
      acc.push(item.issuer);
    }
    return acc;
  });
}

function isCardSchemeEnabled(cardScheme, enabledCardSchemes) {
  return enabledCardSchemes.includes(cardScheme);
}

function formatCVCNumber(val, cardType) {
  let clearValue = clearSpaces(val);
  let obj = getobjFromCardPattern(cardType);
  return clearValue.slice(0, obj.maxCVCLength);
}

function getStrFromIndex(arr, index) {
  return Core__Option.getOr(arr[index], "");
}

function splitExpiryDates(val) {
  let split = val.split("/");
  let value = split.map(item => item.trim());
  let month = Core__Option.getOr(value[0], "");
  let year = Core__Option.getOr(value[1], "");
  return [
    month,
    year
  ];
}

function formatCardExpiryNumber(val) {
  let clearValue = clearSpaces(val);
  let expiryVal = toInt(clearValue);
  let formatted;
  if (expiryVal >= 2 && expiryVal <= 9 && clearValue.length === 1) {
    formatted = `0` + clearValue + ` / `;
  } else if (clearValue.length === 2 && expiryVal > 12) {
    let val$1 = clearValue.split("");
    formatted = `0` + getStrFromIndex(val$1, 0) + ` / ` + getStrFromIndex(val$1, 1);
  } else {
    formatted = clearValue;
  }
  if (clearValue.length >= 3) {
    return formatted.slice(0, 2) + ` / ` + formatted.slice(2, 4);
  } else {
    return formatted;
  }
}

function cardType(val) {
  let match = val.toUpperCase();
  switch (match) {
    case "AMEX" :
      return "AMEX";
    case "BAJAJ" :
      return "BAJAJ";
    case "CARTESBANCAIRES" :
      return "CARTESBANCAIRES";
    case "DINERSCLUB" :
      return "DINERSCLUB";
    case "DISCOVER" :
      return "DISCOVER";
    case "JCB" :
      return "JCB";
    case "MAESTRO" :
      return "MAESTRO";
    case "MASTERCARD" :
      return "MASTERCARD";
    case "RUPAY" :
      return "RUPAY";
    case "SODEXO" :
      return "SODEXO";
    case "VISA" :
      return "VISA";
    default:
      return "NOTFOUND";
  }
}

function formatCardNumber(val, cardType) {
  let clearValue = clearSpaces(val);
  let tmp;
  let exit = 0;
  switch (cardType) {
    case "AMEX" :
      tmp = clearValue.slice(0, 4) + ` ` + clearValue.slice(4, 10) + ` ` + clearValue.slice(10, 15);
      break;
    case "DINERSCLUB" :
      tmp = clearValue.length > 14 ? clearValue.slice(0, 4) + ` ` + clearValue.slice(4, 8) + ` ` + clearValue.slice(8, 12) + ` ` + clearValue.slice(12, 16) + `   ` + clearValue.slice(16, 19) : clearValue.slice(0, 4) + ` ` + clearValue.slice(4, 10) + ` ` + clearValue.slice(10, 14);
      break;
    case "VISA" :
    case "MASTERCARD" :
    case "DISCOVER" :
    case "SODEXO" :
    case "RUPAY" :
      exit = 1;
      break;
    default:
      tmp = clearValue.slice(0, 4) + ` ` + clearValue.slice(4, 8) + ` ` + clearValue.slice(8, 12) + ` ` + clearValue.slice(12, 19);
  }
  if (exit === 1) {
    tmp = clearValue.slice(0, 4) + ` ` + clearValue.slice(4, 8) + ` ` + clearValue.slice(8, 12) + ` ` + clearValue.slice(12, 16) + ` ` + clearValue.slice(16, 19);
  }
  return tmp.trim();
}

export {
  toInt,
  getobjFromCardPattern,
  clearSpaces,
  slice,
  getAllMatchedCardSchemes,
  isCardSchemeEnabled,
  formatCVCNumber,
  getStrFromIndex,
  splitExpiryDates,
  formatCardExpiryNumber,
  cardType,
  formatCardNumber,
}
/* No side effect */
